import { buildWorkflowDiagramPrompt } from '@/ai/prompts'
import { fetchJsonResponse, streamJsonResponses } from '@/ai/api'

export const generateWorkflowDiagram = async ({
  workflow,
  cardTypes,
  attachments,
  stream = true,
  onChunkReceived,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }
  if (stream && typeof onChunkReceived !== 'function') {
    return null
  }

  const messages = buildWorkflowDiagramPrompt({ workflow, cardTypes, stream })

  if (stream) {
    const response = await streamJsonResponses({
      messages,
      attachments,
      aiVersion: workflow.aiVersion,
      onChunkReceived,
      signal: abortController?.signal
    })

    return response || null
  } else {
    const response = await fetchJsonResponse({
      messages,
      attachments,
      aiVersion: workflow.aiVersion,
      signal: abortController?.signal
    })

    return response || null
  }
}
